<template>
  <Teleport to="body">
    <!-- Message Modal -->
    <div aria-hidden="true"
         aria-labelledby="msg-modal-label"
         class="modal fade"
         role="dialog"
         tabindex="-1"
         v-bind="$attrs">
      <form ref="form" :class="{'was-validated': wasValidated}" novalidate @submit.prevent.stop="submitForm">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header pt-4">
              <h5 id="msg-modal-label" class="modal-title">Ihre Nachricht</h5>
              <button aria-label="Close" class="btn-close tracking-message-x" data-bs-dismiss="modal"
                      type="button"></button>
            </div>
            <template v-if="!wasSubmitted">
              <div class="modal-body py-0">
                <div class="form-floating my-3">
                  <input id="floatingInput"
                         class="form-control"
                         name="name"
                         placeholder="Name"
                         required
                         type="text">
                  <label for="floatingInput">Name</label>
                </div>
                <div class="row g-2">
                  <div class="col-md">
                    <div class="form-floating">
                      <input id="floatingInput"
                             class="form-control"
                             name="email"
                             placeholder="E-Mail"
                             required
                             type="email">
                      <label for="floatingInput">E-Mail</label>
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="form-floating">
                      <input id="floatingInput"
                             class="form-control"
                             name="phone"
                             placeholder="Handy-Nr."
                             required
                             type="tel">
                      <label for="floatingInput">Handy-Nr.</label>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-12">
                    <div class="form-floating">
                                          <textarea id="floatingTextarea2"
                                                    class="form-control"
                                                    name="message"
                                                    placeholder="Ihre Nachricht"
                                                    required
                                                    rows="6"></textarea>
                      <label for="floatingTextarea2">Ihre Nachricht</label>
                    </div>
                  </div>
                  <div class="col-12 mt-3">
                    <p class="lead fs-6">Hier finden Sie unsere <a :href="privacyUrl">Datenschutzhinweise</a>.</p>
                  </div>
                </div>

              </div>

              <div class="modal-footer">
                <button :disabled="workers>0"
                        class="btn btn-primary tracking-message-close"
                        data-bs-dismiss="modal"
                        type="button">Schließen
                </button>
                <button :disabled="workers>0"
                        class="btn btn-primary"
                        type="submit"
                >Absenden
                </button>
              </div>
            </template>
            <template v-else>
              <div class="modal-body py-0">
                <p><strong>Vielen Dank</strong>, die Nachricht wurde versendet.</p>
              </div>
              <div class="modal-footer border-0">
                <button class="btn btn-primary tracking-message-close" data-bs-dismiss="modal" type="button">
                  Schließen
                </button>
              </div>
            </template>
          </div>
        </div>
      </form>
    </div>
  </Teleport>
</template>

<script setup>

import {ref} from "vue";

const props = defineProps({
  postUrl: String,
  privacyUrl: String
});

const emit = defineEmits(['success', 'error']);

const csrfToken = () => document.head.querySelector('meta[name="csrf-token"]').content;

const form = ref({});
const wasValidated = ref(false);
const wasSubmitted = ref(false);

const workers = ref(0);

const submitForm = () => {
  if (form.value.checkValidity()) {
    workers.value++;
    const formData = new FormData(form.value);
    axios.post('/ajax/' + props.postUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-CSRF-TOKEN': csrfToken()
      }
    })
        .then(response => {
          wasSubmitted.value = true;
          form.value.reset();
          emit('success', response);
        })
        .catch(error => {
          emit('error', error);
        })
        .finally(() => {
          workers.value--;
        });
  }
  wasValidated.value = true;
}

</script>

<style scoped>

</style>